import React, { forwardRef } from 'react';
import { SketchPicker } from 'react-color';
import Select from 'react-select';
import parse from 'html-react-parser';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import _ from 'lodash';
export class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      selected: this.props.multiple ? [] : '',
      disabled: this.props.disabled ? true : false,
      noResultsText: 'No Results Found',
    };
    ['onInputChange', 'onFocus'].forEach((fn) => {
      this[fn] = this[fn].bind(this);
    });
  }
  UNSAFE_componentWillReceiveProps(props) {
    var records = props.options.map((d, index) => {
      return {
        value: d.id,
        label: d.name,
        image: typeof d.image !== 'undefined' ? d.image : '',
      };
    });
    var objToBeUpdated = {
      records: records,
      noResultsText: records.length > 0 ? '' : 'No Results Found',
      disabled: props.disabled,
    };

    this.setState(objToBeUpdated);

    if (typeof props.selected !== 'undefined') {
      if (props.multiple) {
        var selected = props.selected.map((d, index) => {
          return d.value;
        });
        this.setState({ selected: selected });
      } else {
        this.setState({ selected: props.selected });
      }
    }
  }
  UNSAFE_componentWillMount() {
    var records = this.props.options.map((d, index) => {
      return {
        value: d.id,
        label: d.name,
        image: typeof d.image !== 'undefined' ? d.image : '',
      };
    });

    this.setState({ records: records });

    if (typeof this.props.selected !== 'undefined') {
      if (this.props.multiple) {
        var selected = this.props.selected.map((d, index) => {
          return d.value;
        });
        this.setState({ selected: selected });
      } else {
        this.setState({ selected: this.props.selected });
      }
    }
  }
  onInputChange(option) {
    if (
      typeof this.props.onInputChange !== 'undefined' &&
      ((!this.props.allowEmptySearchKeyworkd && option !== '') ||
        this.props.allowEmptySearchKeyworkd)
    ) {
      this.props.onInputChange(option);
    }
  }
  onFocus() {
    if (typeof this.props.onFocus !== 'undefined') {
      this.props.onFocus();
    }
  }
  render() {
    var self = this;
    var handleChange = function (option) {
      self.props.onChange(option);
      self.setState({
        selected: self.props.multiple ? option : option ? option.value : '',
      });
    };
    return (
      <div class="select-wrapper">
        <p class="note m0">
          {typeof this.props.label !== 'undefined'
            ? this.props.label
            : 'Type to search item.'}
        </p>
        <Select
          multi={this.props.multiple}
          disabled={this.state.disabled}
          options={self.state.records}
          optionRenderer={this.props.customLabel}
          valueComponent={this.props.customSelected}
          style={this.props.style}
          value={this.props.value ? this.props.value : this.state.selected}
          onChange={handleChange}
          clearable={
            typeof this.props.isClearable !== 'undefined'
              ? this.props.isClearable
              : false
          }
          required={this.props.required}
          onInputChange={this.onInputChange}
          onFocus={this.onFocus}
          noResultsText={
            this.props.isLoading ? 'Loading ...' : self.state.noResultsText
          }
          onSelectResetsInput={false}
          onBlurResetsInput={true}
          autoBlur
          placeholder={
            typeof this.props.placeholder ? this.props.placeholder : 'Search'
          }
          // isLoading={this.props.isLoading}
        />
      </div>
    );
  }
}

export class OnOffSwitch extends React.Component {
  render() {
    let { Active, Action } = this.props;
    return (
      <label class="switch ">
        <input
          type="checkbox"
          name="onoffswitch"
          class="onoffswitch-checkbox success"
          onClick={Action}
          defaultChecked={Active === 1}
        />
        <span class="slider" />
      </label>
    );
  }
}

export const Loading = (hasLoadingText) => {
  return (
    <p style={{ fontSize: 16, textAlign: 'center', margin: 0 }}>
      <i class="fa fa-circle-o-notch fa-spin fa-fw" />{' '}
      {hasLoadingText ? 'Loading...' : ''}
    </p>
  );
};

export const LoadingIcon = () => {
  return (
    <p style={{ fontSize: 16, textAlign: 'center', margin: 0 }}>
      <i class="fa fa-circle-o-notch fa-spin fa-fw" />
    </p>
  );
};

export const DeleteModal = (props) => {
  const {
    type,
    type_value,
    delete_function,
    note = '',
    cancel_function,
  } = props;

  return (
    <div
      class="modal fade delete-modal bg-overlay"
      id={props.id}
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class={`modal-dialog modal-md ${props.dialogClass}`} role="document">
        <div class="modal-content">
          <div class="modal-header border-none pd20 pdl40 pdr40">
            <div class="row">
              <div class="col-lg-10 col-md-10 col-sm-10">
                <p class="text-size18 text-sldred text-semi-bold mb0">
                  {props.id === 'deleteWorkstream'
                    ? `Delete ${type}`
                    : `Delete this ${type}`}
                  ?
                </p>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2">
                <a
                  class="text-right text-black"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={cancel_function}
                >
                  <i class="material-icons text-black text-size22">close</i>
                </a>
              </div>
            </div>
          </div>
          <div class="modal-body bt">
            {props.id === 'deleteWorkstream' ? (
              <p class="text-black">
                Deleting this workstream will permanently remove all its tasks.
                Related files, however, can still be accessed through the
                Library.
              </p>
            ) : (
              <p class="text-black">
                Do you wish to proceed with deleting this {type}?
              </p>
            )}
            {note !== '' && <p class="text-center">{note}</p>}
          </div>
          <div class="modal-footer bt">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-4">
                <button
                  type="button"
                  class={`btn btn-secondary btn-cancel text-black ${props.deleteInProgress ? 'disabled' : ''}`}
                  data-dismiss="modal"
                  onClick={cancel_function}
                >
                  Cancel
                </button>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                <button
                  type="button"
                  class={`btn btn-danger btn-delete ${props.deleteInProgress ? 'disabled' : ''}`}
                  onClick={delete_function}
                >
                  {props.deleteBtnLabel
                    ? props.deleteBtnLabel
                    : props.id === 'deleteWorkstream'
                      ? `Delete`
                      : `Delete ${type}`}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ensurePx = (value) => {
  if (!value || isNaN(value) || value.includes('px') || value.includes('%')) {
    return value;
  }

  return `${value}px`;
};

export const editorLink = (text) => {
  const httpRegex = /((http|https):\/\/[^\s]+)/g;
  const hrefRegex = /<a\s.*?href=[\"\']((http|https):\/\/[^\s]+)/g;
  //checking if <a has href link
  const hyperLink =
    /<a\s.*?href=[\"\']((http|https):\/\/[^\s]+)[\"\']*?>(.*?)<\/a>/gm;
  text = text.replace(`target="_self"`, ``);
  try {
    if (text) {
      text = text.replace(/style="([^"]*)"/g, (match) => {
        return match
          .replace(
            /height\s*:\s*([^;]+);?/gi,
            (m, p1) => `height: ${ensurePx(p1)};`
          )
          .replace(
            /width\s*:\s*([^;]+);?/gi,
            (m, p1) => `width: ${ensurePx(p1)};`
          );
      });

      let val = text.replace(hyperLink, (data) => {
        const el = document.createElement('div');
        el.innerHTML = data;
        const child = el.childNodes[0].childNodes[0].outerHTML;

        if (child) {
          return child;
        }
        return data;
      });

      // convert link text  to href link
      const matchReqex = val.match(hrefRegex) ? hrefRegex : httpRegex;
      return val.replace(matchReqex, function (url) {
        let link = url.replace(/['"]+/g, '').split('<');
        if (link.length > 0) {
          const urlLink = link.shift();
          const extra = link.map((s) => {
            return '<' + s;
          });
          return (
            '<a href="' +
            urlLink +
            '" target="_blank">' +
            urlLink +
            '</a>' +
            extra
          );
        }
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
      });
    } else {
      return text;
    }
  } catch (error) {
    return text ? text : '';
  }
};
export const urlify = (text, mention = false) => {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  if (text) {
    let val = text.replace(urlRegex, function (url) {
      //let link = url.split('</')[0]//handle for formatting editor
      return '<a href="' + url + '" target="_blank">' + url + '</a>';
    });
    if (!mention) {
      val = val.replace(/\[/g, '<i>[').replace(/\]/g, ']</i>');
    }
    return val;
  } else {
    return text;
  }

  // or alternatively
  // return text.replace(urlRegex, '<a href="$1">$1</a>')
};

export const MentionConvert = ({ string }) => {
  try {
    const text = urlify(string, true);
    const split = text.split(/{([^}]+)}/g).filter(Boolean);

    return (
      <p class="mb0 mention" style={{ wordBreak: 'break-all' }}>
        {split.map((o, index) => {
          const regEx = new RegExp(/\[([^\]]+)]/);
          if (o.match(regEx)) {
            let mentionString = o.replace(/[\[\]']+/g, '');
            return (
              <strong key={index}>
                <span style={{ color: '#5080fb' }}>
                  {mentionString.replace(/[(^0-9)]/g, '')}
                </span>
              </strong>
            );
          } else if (o.match(/^http\:\//) || o.match(/^https\:\//)) {
            return (
              <a key={index} href={o}>
                {o.replace(/\r?\n/g, '<br />')}
              </a>
            );
          } else {
            return parse(o.replace(/\r?\n/g, '<br />'));
          }
        })}
      </p>
    );
  } catch (error) {
    console.log(error);
  }
};

export const ProgressBar = ({ data }) => {
  return (
    <div class="progress">
      {_.map(data, ({ label, value, color }, index) => {
        return (
          <div
            class="progress-bar"
            key={index}
            role="progressbar"
            style={{ width: `${value}%`, backgroundColor: color }}
          />
        );
      })}
    </div>
  );
};

export class ColorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show_color_picker: !!props.forceShowPicker,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.forceShowPicker && !prevProps.forceShowPicker) {
      this.setState({ show_color_picker: true });
    }
    if (!this.props.forceShowPicker && prevProps.forceShowPicker) {
      this.setState({ show_color_picker: false });
    }
  }

  render() {
    const { show_color_picker } = this.state;
    const {
      color,
      onSelect,
      placeholder = 'Select Color',
      required,
      forceShowPicker,
    } = this.props;

    const handleBlur = () => {
      this.setState({ ...this.state, show_color_picker: false });
    };

    // Picker visibility is always controlled by state
    const pickerVisible = show_color_picker;

    return (
      <ClickAwayListener onClickAway={handleBlur}>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            name="project_color"
            placeholder={placeholder}
            required={required}
            value={typeof color === 'undefined' || color === null ? '' : color}
            class="form-control"
            onFocus={() => this.setState({ show_color_picker: true })}
            onChange={() => {}}
            style={{ display: forceShowPicker ? 'none' : undefined }}
          />
          <div
            class="color-tab"
            style={{
              background: color === null ? '#000000' : color,
              width: forceShowPicker ? 16 : 18,
              height: forceShowPicker ? 16 : 18,
            }}
          ></div>
          {pickerVisible && (
            <div style={{ position: 'relative' }} class="picker-modal">
              <SketchPicker
                color={
                  typeof color === 'undefined' || color === null
                    ? '#2980b9'
                    : color
                }
                onChange={onSelect}
              />
              <a
                class="color-picker-close"
                onClick={() => this.setState({ show_color_picker: false })}
                style={{
                  left: forceShowPicker ? 200 : 'inherit',
                  position: 'absolute',
                }}
              >
                <i class="material-icons" aria-hidden="true">
                  close
                </i>
              </a>
            </div>
          )}
        </div>
      </ClickAwayListener>
    );
  }
}

export class Searchbar extends React.Component {
  constructor(props) {
    super(props);
    ['handleShowSearch', 'handleChange'].forEach((fn) => {
      this[fn] = this[fn].bind(this);
    });
  }

  shouldComponentUpdate(nextProps) {
    if (!_.isEqual(nextProps.clear, this.props.clear) && nextProps.clear) {
      const { handleCancel } = nextProps;
      const { searchInput = '', searchIcon = '' } = this.refs;
      const searchClassList = searchInput !== '' ? searchInput.classList : '';
      const searchIconClassList = searchIcon !== '' ? searchIcon.classList : '';

      searchClassList.add('hide');
      searchIconClassList.remove('fa-times-circle-o');
      searchIconClassList.remove('ml5');
      searchIconClassList.add('fa-search');
      searchInput.value = '';

      handleCancel();
    }

    return true;
  }

  handleShowSearch() {
    const { handleCancel } = this.props;
    const { searchInput = '', searchIcon = '' } = this.refs;
    const searchClassList = searchInput !== '' ? searchInput.classList : '';
    const searchIconClassList = searchIcon !== '' ? searchIcon.classList : '';

    if (searchClassList.contains('hide')) {
      searchClassList.remove('hide');
      searchIconClassList.remove('fa-search');
      searchIconClassList.add('fa-times-circle-o');
      searchIconClassList.add('ml5');
    } else {
      searchClassList.add('hide');
      searchIconClassList.remove('fa-times-circle-o');
      searchIconClassList.remove('ml5');
      searchIconClassList.add('fa-search');
      searchInput.value = '';

      handleCancel();
    }
  }

  handleChange(e) {
    const { handleChange } = this.props;
    const filterState = { [e.target.name]: e.target.value };

    if (
      typeof e.key !== 'undefined' &&
      e.key === 'Enter' &&
      e.target.value !== ''
    ) {
      handleChange(filterState);
    }
  }

  render() {
    const { name } = this.props;

    return (
      <div style={{ display: 'flex', marginRight: 10 }}>
        <div>
          <input
            type="text"
            name={name}
            class="form-control hide"
            ref="searchInput"
            placeholder="Type and press enter to search"
            onKeyPress={this.handleChange}
          />
        </div>
        <a class="logo-action text-grey" onClick={this.handleShowSearch}>
          <i ref="searchIcon" class="fa fa-search" aria-hidden="true" />
        </a>
      </div>
    );
  }
}

export const DatePickerCustomInput = forwardRef(
  ({ value, onClick, onClear, placeholder }, ref) => {
    return (
      <div className="date-picker-wrapper">
        <div className="react-datepicker__input-container">
          {value && (
            <i
              onClick={onClear}
              aria-hidden="true"
              className="date-picker-icon fa fa-times"
            />
          )}
          <input
            className="date-picker-input form-control"
            type="text"
            value={value}
            placeholder={placeholder}
            onClick={onClick}
            autoComplete="false"
            readOnly={true}
            ref={ref}
          />
        </div>
      </div>
    );
  }
);
